module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "x-large"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")])])]), _vm._v("he narrow halls of Shadowlight Academy had grown incredibly dim in the absence of Braxton and Asher.  I no longer had an ally, no one to laugh with.  I put on a brave face, ignoring the pity-filled glances of many and the occasional spiteful smirk.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Passing Braxton’s locker was a daily ritual, whether I had needed to pass by it or not.  Instinctively, my hand went out to it as it had every day for over a month.  I wanted to feel his energy, to find the faint scent of him that still lingered.  It was almost gone, probably just a fragment of my imagination.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A month, I thought as I stared at his locker. It seemed my life had come to a sudden stop on that night.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The demons had even grown quiet; whether out of fear or with the plot to cause greater havoc, I didn’t yet know.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My fingers brushed over the combination lock that kept Braxton’s things imprisoned.  No one had bothered to clear it.  He’d not even come back to get anything, not even the Lacrosse shirt that I knew was still inside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("What other secrets lied inside, I wondered.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As I stood there, lost in my reverie, the occasional shoulder brushed along my back as students hurried by on their way to their classes, their purpose clear and strong with every stride, the importance of this education fierce.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And here I was just barely getting by.  Braxton had been instrumental in getting my average up and now each class was a struggle. Words couldn’t articulate how much I missed him. Not only was he my tutor and friend, but also my lover. I missed his voice. I missed his touch...how he would hold me and kiss me softly sometimes.  And how he would spend hours pleasuring me from head to toe with his mouth, his hands, and his body. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I leaned my forehead to his locker and closed my eyes. The image of him quickly came to me; that first day, that brief glance; he, dressed for Lacrosse, and I in the backseat of my parents’ car.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Our connection had been built in that very moment and I knew it was still strong.  Even if he was clear across the Atlantic in England while I remained here to put all the pieces together, I felt that connection.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Inhaling, his scent came to me, so sweet and so tantalizing.  So real.  So confusing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Lothario had told me to look for others, others like me.  He’d told me to find my guardian.  I thought I had, but now?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The haunting dream I’d had the night before came to me, the feelings I’d felt for that boy, that strange and mysterious boy, were so real, my heart tightened at the thought of him.    The chase and the need to catch him.  The embrace and the desire to touch him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My soul.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His words of warning sounded in my ear.  I shouldn’t have trusted.  I should have slain.  My soul was at stake.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("And my heart was in the way.  Even now I could feel the love for that boy, and the need to save him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I just had to figure out who it was I had to save; Braxton or Moore. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Reluctantly, I left the locker, my focus on seeing Ms. Bright.  Perhaps she could help me.  Surely she had the means to get in touch with Brax.  Turning into the crowd of students, I walked against the flow to the principal’s office. Through the throngs of beautiful flowing hair, bright white smiles and perfect features, I saw two dark shadows at the other end of the hall.  My hand went to my crucifix, my focus redirected to the odd pair.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Amidst pristine uniforms and youthful beauty, the couple was sorely out of place, yet the beautiful youths passed them by, oblivious of their presence.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The parents, I thought.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In my great absorption of Braxton’s absence and the troubling nightmare, I’d set aside the late night visit.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My stride was strong and determined as I closed in on them.  I anticipated a complicated chase or fierce battle, but they simply stood there, their eyes hopeful and their mouths grim.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("As my lips parted to question them, they vanished in the shadows, leaving me to wonder if I’d really seen them at all.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("If they really were Brax’s parents, why were they coming to me now?")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His parents had disappeared while investigating paranormal activity. Perhaps they’d been caught in the middle of something far bigger and stronger than they’d imagined.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Theirs was no doubt a supernatural disappearance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It all left me with too many questions; annoying questions I didn’t have the answers to.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Returning my focus to my initial aim, I shook the ghostly parents from my head and turned to the principal’s office.  I needed some answers, some clarification about Brax.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Foregoing the polite rap on the door, I barged into Ms. Bright’s office.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Standing at the filing cabinet, she turned to me with a start, her eyes wide and alert.  In a heartbeat she regained her composure.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lux,” she said with a professional smile.  “You startled me.  I thought you were someone else.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Or something else,” I muttered as she shoved a file back into the cramped drawer and pushed it shut.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How is your father doing?  I know he was close to Dr. Kingsley.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I had little time for chatter and wanted to hurry to the topic of Brax.  “He’s doing better, thank you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So unfortunate.  So tragic.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It certainly is,” I said with controlled impatience.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Though I had few encounters with him, I do miss Dr. Kingsley.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ms. Bright, I wanted to ask you about Braxton.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oh my, yes.  That’s the most tragic aspect of this whole sordid story.  Poor young man; to be orphaned and left to his uncle only to lose his uncle so violently.  It’s an unfair amount of tragedy for one young life.  And now to be separated from his friends and sent to a boarding school in England.  I do hope he’s faring well.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Ms. Bright, why was he sent to England?  He’s old enough to stay here on his own.  He inherited his uncle’s estate, his fortune, so money’s not an issue.  He has friends here and a school and neighborhood he knows and feels comfortable in.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked at me with chagrin.  “I wished he’d stayed, too, Lux.  He really is a fine boy, an admirable young man, but he was offered various options upon the death of his uncle.  I guess, in the end, there were just too many bad memories here and England appealed to him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("That was impossible, I wanted to argue.  He had far too much here.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“The estate needs tending.  It needs him.” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I need him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes, I’ve heard it’s been temporarily left in the hands of a neglectful caretaker.  Such a beautiful home.  Apparently Dr. Kingsley’s immaculate garden is already overrun with weeds.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Braxton needs to come back.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ms. Bright’s eyes softened.  “You know, the bizarre circumstances surrounding Dr. Kingsley’s murder left Braxton very shaken.  Chances are he won’t return until it’s resolved.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But we all know Shayne so brutally killed Dr. Kingsley, I wanted to shout out.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Asher was wrongly imprisoned,” I said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve heard some people say that.  I must say, I was surprised when I heard he’d been formally accused.  Despite his gruff exterior and bad boy persona, I’ve always liked him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Isn’t there anything you can do to get Brax back to Shadowlight, back to San Francisco?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She chuckled softly.  “I wish I could, but it’s completely out of my hands.  As bad as I feel about this whole episode and about Asher’s imprisonment, Braxton has the final decision on where he stays, and he decided on England.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“That was a month ago, when everything was fresh and confusing. Surely now he realizes he belongs here.  I’m sure he’s suffering greatly. I’m sure he’s lonely and longing to come home.  All he needs is a little push, a little reminder of the people here who are ready to help him.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m sorry, Lux.  There’s really nothing I can do.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Fine,” I muttered in exaggerated defeat.  It was hard to believe how close Braxton and I had quickly become, so inseparable, so connected, right from the start.  When we recognized we shared common abilities, we grew closer still.  And now he was a world away.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With Brax so far away and unreachable, and Asher in jail, I was left alone to deal with the things that were going on at the Academy, alone to face Moore and Shayne as they went about their lives as if nothing had ever happened.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Is there any way you can just contact him?  Just let him know I’m trying to contact him?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked woefully at me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Please, Ms. Bright.  I’ve left dozens of messages with a relative of Braxton’s, but I don’t think they’re relating the messages to him.  It’s the only contact number I have and it’s useless.  No email address, no Facebook, no Braxton.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She offered me a faint and sympathetic smile.  “You must truly miss him,” she said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded hopefully.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look.”  She pulled out a little notepad.  “I can send him a friendly note, just a few words to remind him how we’re all still thinking of him and wish him well.  Just a warm note from a friend, not from a school administrator.  That’s all I can do.  I can’t promise I’ll get more of a response than you have.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted to stick around to see her pull out his address, or even the name of the school he was attending, but she simply smiled and offered a polite but dismissive nod.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pleased to have her at least make an attempt, I rose and turned to the door.  “I really appreciate this.  It may not give me the results I want right away, but it’s a start.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I slid back into the hall and joined the remaining stragglers who leisurely headed to their first class of the day.  Joining the relaxed pace, I headed to my French class with a sense of accomplishment.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Just three doors from my class, a hand clamped to my shoulder.  My heart shut out Brax and my body immediately went into battle mode.  Wasting no time I turned, grabbed the offending hand in both mine and twisted it around, effectively pushing it up into the back of the person who’d dared touch me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was tall, his shoulders strong and wide and inches above mine, but I didn’t care.  I held nothing back as I shoved him into a locker, denting the narrow metal door in the process.  Just as swiftly as I banged his head to the door, he turned my hold against me.  With strength that surprised and surpassed me, he grabbed my wrists in one hand, twisted around and shoved me back into the locker.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Overcome by lust, I had to inhale deeply as I tried to understand the reaction of my body.  Heated and hungry, it was far from the reaction of the warrior I was.  My legs were suddenly weak and my breath hot and labored.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I met his gaze, before I raised my eyes over the breadth of his shoulders, the strong line of his chin and perfect lips, I knew him; his scent, his unearthly power, the touch of his hands on my skin, the brush of his lips on mine, and his relentless ability to so easily conjure up such great lust and longing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("One strong hand brought my arms above my head, pinned to the lockers and leaving me helpless to defend myself, and when he pushed his body to mine, pinning me more securely to the lockers, I knew I didn’t want to fight him off.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“It’s not easy sneaking up on a girl like you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What do you want, Moore?” My voice was strong despite the thrills and hunger that left my body weak.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A moment.  A word.  A touch.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stared at him, captivated by his beauty. His lips were full, more sensual than ever. I fought to remain strong, but my breathing came in short sharp huffs, betraying the full degree of desire I felt for him.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He leaned in closer, his heated breath brushing my cheek.  His lips parted, hungrily aiming to take a hold of mine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("With willpower that surprised me, I turned away from his oncoming kiss, only to hear an amused little sigh spill through his pouty lips.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“So there’s really no way for a guy to surprise you and get a kiss.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not without getting pummeled.” This time my voice betrayed me, coming out in an odd croak that contradicted my words.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Moore’s lips curved into a devilishly wicked grin as he leaned closer still.  “I wouldn’t mind getting pummeled by you so long as we can end up this close.”  He brushed his nose along mine. “So exquisitely and excruciatingly close.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I closed my eyes, trying to blot out the intense and overwhelming desire to kiss him.  Despite the open space and the few students who still lingered, I wanted nothing more than to make out with him, to hold him passionately and never let go.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Why can’t I shake the need to be close to you,” I muttered through labored breaths.  In the instant the words were spoken I knew the answer.  He was the son of a succubus and a human; he’d inherited the great allure of darkness with the irresistible appeal of sexuality.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was a dangerous combination.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You can have any girl you want,” I mumbled, more to myself than he.  But as the true urgency of the situation sunk in, as I realized how angry I still was at him, I repeated my words with conviction and pushed him off me.  “Just stay away from me, Moore Hatchett.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stomped away, inhaling the cool air in the hopes of ridding me of the warmth of his touch.  I heard his footsteps behind me, hesitant at first, then with determination.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Lux.” He grabbed my arm to stop me, but released me the moment he caught my unwavering glare.  He simply walked beside me.  “I know what I did was unforgivable, but you have to understand, it’s a side of me I can’t control.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I arrived at my class, the door already shut.  A quick glance in the tiny window and I could see students milling about, chatting quietly, and practicing their "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Français")]), _vm._v(". Class hadn’t yet begun. I grabbed the doorknob, intent on making it in time and escaping Moore, but he hurried to cover my hand with his, stopping me from going in.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m already going to be late as it is, Moore.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I need you to forgive me.  I need to know you understand.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You’re well beyond forgivable.  Thanks to you, two lives have been ruined.  Brax is off in some boarding school in England and Asher is sitting in some jail cell for something your sister did.  I’ll never forget the horrible images of that night, Moore, but the fact that you continue to defend Shayne, the fact that you won’t stand up and clear Asher’s name, that is what makes this so unforgivable.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("His fingers played on the back of my hand while his gaze fell to the floor.  “She’s my sister, Lux.  I can’t.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Right,” I snapped and pulled my hand free.  “And I can’t forget what you both did.  I should have slain you long ago.  I should slay you, right here, right now.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I know.” He met my harsh glare with the first hint of redemption I’d seen in his eyes.  “But you didn’t and you won’t, and that is making me a better person.  Somewhere deep inside, I know you believe in me.  Knowing that keeps me fighting the dark.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I turned away from his gaze, torn by too many painful emotions.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I need you, Lux.”  His voice was a gentle whisper, filled with affection and hope.  “We both know the chemistry we share; it’s undeniable, but we also connect on a more profound level.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("When I didn’t look at him, he sighed, a heartbreaking sound that had me wincing.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Give me a chance.  Let me prove to you the man I really am.  You know how strong the dark side can be.  You know how difficult it is keeping it at bay, keeping the good in the forefront.”  He brought a tender finger to my chin and turned me to him.  “I love you, Lux.  I may have an awful way of showing it, but I love you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I wanted to slap him.  Furious at him for all that had happened since my arrival at Shadowlight and furious with myself for all the emotions he conjured up. I wanted to slay him. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He brought his fingers to my creased brow, soothing and all the more infuriating.  When he kissed my hand, a kiss chaste and almost too pure, the need to fight him battled with the need to touch him, to feel his body against mine.  My anger surged and my hand stiffened in his.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Before I could protest, tell him that he was a retched man, a manipulative beast, he kissed me, hard, passionate and possessive.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I heard an erotic groan and was shocked to find it came from my own throat.  This wasn’t how I should react to him, and after months of telling myself that, I still found myself unable to control the lustful desires he always brought out in me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Just as my head reeled and my body succumbed, a sharp knock on the small window broke us apart.  My eyes bleary and my lips still full with passion, I turned to the stern and displeased squint of Madame Casavant.  She cracked the door open.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Are you coming in Mademoiselle Lux or are you simply going to tease the entire class with your early morning interlude?” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Oui, Madame Casavant.  I’m coming right in.”  I gave the door a gentle yet firm little nudge and quickly turned to Moore.  Before he left I had one urgent question.  “I always feel faint when you kiss me; dizzy.  I’m fine now.  Why?  Why didn’t your kiss affect me as it always does?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pain shadowed his eyes and his jaw tightened.  “I held back,” he said.  “I know there’s a side to what happens between us that can hurt you; leave you dizzy and weak.  I didn’t really know the full effect that first time I kissed you.  For a moment I thought I’d killed you.  Since then I’ve worked to control it, to hold back.  It’s taken a while to get the hang of it, but I can control it well enough now.  It’s hard, almost painful, but for you...” ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He glanced at the window with Madame Casavant’s face still in it and looked back at me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I want to be with you, Lux, more than you know, more than you realize.  I almost want it too much.  I think the more time I spend with you, the easier it’ll get for me to control everything the dark side throws at me.  You’re already making me stronger, Lux.  Can’t you see?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I stared at him, the beautiful face I never tire of looking at, the sensually touchable blonde hair and the lips I wanted desperately to taste again.  A hungry sigh escaped me before I could contain it.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Surely he heard it.  Surely he felt victorious.  I looked for that trace of cockiness, or male pride, but there was none; just a faint smile.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Be with me, Lux,” he whispered.  “Help me through this.  I’d do anything to prove to you I’m not the monster you think of me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Your reputation as a monster is your own doing, not mine, remember?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Let me prove it to you,” he repeated.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I considered his offer.  He was a rich and powerful guy.  No doubt he can help me. “Okay,” I said with a cocky grin.  “Help me get Braxton back to San Francisco.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A slap in the face would have been kinder.  His eyes widened with shock, drooped with dismay then narrowed with jealousy. “You’re still...” He inhaled sharply and tried again.  “You’re still into him?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I need him back here,” I said matter of factly.  “And you need to prove you can be trusted.  Two birds with one stone.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“But, Lux.  Brax and I fought over you... all the time.  Now that I can finally have you all to myself, you want him to come back?  And you want me to help get him back?  Damn, you’re killing me, you know that?”  He looked to the ceiling and sighed.  “You won’t even look at me once he’s here again.”  Shaking his head, he returned his gaze to me.  “Remind me again why I should help get my thorn back in my side.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Because you want me to forgive you, to trust you.”  I smiled, amused by his conflicting emotions.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He nodded, a wry grin on his lips.  “Yeah, right.”  He kissed my hand.  “You're the only one for me, and I’ll do as you ask.  Meet me after school.  We’ll figure a way to get him back.  I’ll hate it every step of the way, but I’ll do it.  I’ll pick you up and we’ll talk it out.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Okay, but no funny business.”  I tore my hand from his and held up a reprimanding finger.  “And I mean it, Moore.  One false move and all bets are off.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He offered me a very formal and absolutely adorable salute.  “On my honor, Mademoiselle.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "x-large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 3")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26644936","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c006.vue
// module id = 75
// module chunks = 0